import useApi from 'src/api/useApi';

const useSyncHelper = () => {
    const { postApiData } = useApi();

    const syncItems = async (getAllItems, deleteItem, requestKeys: string[], idKey: string) => {
        const items = await getAllItems();
        items.sort((a, b) => a.lastUpdated - b.lastUpdated);

        try {
            let i = 0;
            for (const item of items) {
                const matchingRequestKeys = requestKeys.filter((r) => item[r]);

                for (const requestKey of matchingRequestKeys) {
                    const request = item[requestKey];
                    if (request) {
                        const requests = Array.isArray(request) ? request : [request];
                        for (const req of requests) {
                            await postApiData({ fullUrl: req.url, data: req.body, skipRefreshCacheEndpoints: i < items.length - 1 });
                        }
                    }
                }

                if (matchingRequestKeys.length > 0) {
                    await deleteItem(item[idKey]);
                }
                i++;
            }
        } catch (error) {
            console.error(`Error syncing items with keys:`, requestKeys, error);
        }
    };

    return {
        syncItems,
    };
};

export default useSyncHelper;
